import type { FC } from 'react';
import { Card, Heading, Toggle, ToggleGroup } from '@george-labs.com/design-system';

import { t } from '@luna/i18n';
import type { AppearanceMode } from '@shared/dark-mode-utils';

import { useDarkMode } from './useDarkMode';
import styles from './DarkMode.module.scss';

export const DarkMode: FC = () => {
    const { saveAppearanceMode, appearanceMode } = useDarkMode();

    return (
        <Card data-cy="dark-mode-switch">
            <Heading level={3} className="mb-3 mb-sm-0">
                {t('main.settings.theme.title')}
            </Heading>
            <ToggleGroup
                layout={ToggleGroup.LAYOUT.REGULAR}
                type={ToggleGroup.TYPE.RADIO}
                toggledItems={[appearanceMode]}
                onToggle={([selectedAppearanceMode]) =>
                    saveAppearanceMode(selectedAppearanceMode as AppearanceMode)
                }
                className={styles.switchOptions}
            >
                <Toggle
                    type={Toggle.TYPE.RADIO}
                    id="system"
                    imageUrl="/assets/img/profile/theme-settings/system.svg"
                    name="theme-toggle"
                    value="SYSTEM"
                    label={t('main.settings.theme.system')}
                    data-cy="system-option"
                />
                <Toggle
                    type={Toggle.TYPE.RADIO}
                    id="light"
                    imageUrl="/assets/img/profile/theme-settings/light.svg"
                    name="theme-toggle"
                    value="LIGHT"
                    label={t('main.settings.theme.light')}
                    data-cy="light-option"
                />
                <Toggle
                    type={Toggle.TYPE.RADIO}
                    id="dark"
                    imageUrl="/assets/img/profile/theme-settings/dark.svg"
                    name="theme-toggle"
                    value="DARK"
                    label={t('main.settings.theme.dark')}
                    data-cy="dark-option"
                />
            </ToggleGroup>
        </Card>
    );
};
